export enum ALIEO_TYPE {
  ASSET,
  LIABILITY,
  INCOME,
  INCOME_SELF_EMPLOYED_V2,
  EXPENSE,
}
